import { makeStyles } from '@material-ui/core'

const styles = makeStyles(() => ({
  textDescription: {
    whiteSpace: 'break-spaces',
  },
}))

export default styles
